class BaseSelect {
    constructor(element) {
        this.element = element
        this.init()
    }

    init() {
        this.initResizeObserver()
        this.initSearchListeners()
        this.initClickListener()
        this.removeAttrDisabledInInput()
    }

    initResizeObserver() {
        const observer = new ResizeObserver(function () {
            this.toggleScrollable()
        }.bind(this))

        this.toggleScrollable()
        observer.observe(this.list)
    }

    toggleScrollable() {
        this.list?.classList.toggle('base-select__list--scrollable', this.hasVerticalScrollbar(this.list))
    }

    initSearchListeners() {
        this.search.addEventListener('focus', this.initFocusHandler.bind(this))
        this.search.addEventListener('blur', this.initBlurHandler.bind(this))
        this.search.addEventListener('input', this.initSearchHandler.bind(this))
    }

    initFocusHandler() {
        !this.searchValue && this.upPlaceholder()
        this.activateLabel()
    }

    initBlurHandler() {
        !this.searchValue && this.downPlaceholder()
        this.deactivateLabel()
    }

    initSearchHandler(e) {
        this.filterSelectOptions(e.target.value);
        this.changeLastOption(e.target)
    }

    filterSelectOptions(queryString) {
        queryString = queryString.toLowerCase().trim();
        this.options.forEach((option) => {
            const optionText = option.textContent.toLowerCase().trim();
            if (optionText.includes(queryString)) {
                option.classList.remove('hidden');
            } else {
                option.classList.add('hidden');
            }
        });
        const noResultsFound = this.options.length === this.element.querySelectorAll('.js-select-item.hidden').length;
        this.noOptions.classList.toggle('hidden', !noResultsFound);
    }

    changeLastOption() {
        this.currentLastVisibleOption?.classList.remove('last')
        this.lastVisibleOption?.classList.add('last')
    }

    initClickListener() {
        this.element.addEventListener('click', (e) => {
            const target = e.target;
            const selectItem = target.closest('.js-select-item');

            if (selectItem) {
                this.selectOption(selectItem);
            }
        });
    }

    selectOption(newOption) {
        const value = newOption.dataset.optionValue
        this.setInputOutputValue(value);
        this.deactivateCurrentActiveOption();
        this.activateOption(newOption)
        this.triggerOptionChange(value)
    }

    setInputOutputValue(value) {
        this.inputOutput.value = value
    }

    deactivateCurrentActiveOption() {
        this.activeOption?.classList.remove('active');
    }

    activateOption(option) {
        option.classList.add('active')
    }

    triggerOptionChange(value) {
        const selectEvent = new CustomEvent('option:changed', {
            bubbles: true, detail: {
                value
            }
        });
        this.element.dispatchEvent(selectEvent);
    }

    hasVerticalScrollbar(element) {
        return element.scrollHeight > element.clientHeight
    }

    removeAttrDisabledInInput() {
        this.search.removeAttribute('disabled')
    }

    upPlaceholder() {
        this.placeholder?.classList.add('base-select__placeholder--up')
    }

    downPlaceholder() {
        this.placeholder?.classList.remove('base-select__placeholder--up')
    }

    activateLabel() {
        this.label?.classList.add('active')
    }

    deactivateLabel() {
        this.label?.classList.remove('active')
    }

    get label() {
        return this.element.querySelector('.js-select-label')
    }

    get placeholder() {
        return this.element.querySelector('.js-select-caption-placeholder')
    }

    get options() {
        return this.element.querySelectorAll('.js-select-item')
    }

    get noOptions() {
        return this.element.querySelector('.js-select-item-no-options')
    }

    get list() {
        return this.element.querySelector('.js-select-list')
    }

    get search() {
        return this.element.querySelector('.js-select-search')
    }

    get searchValue() {
        return this.search.value
    }

    get inputOutput() {
        return this.element.querySelector('.js-select-output');
    }

    get activeOption() {
        return this.element.querySelector('.js-select-item.active')
    }

    get lastVisibleOption() {
        const visibleOptions = this.element.querySelectorAll('.js-select-item:not(.hidden)')
        return visibleOptions[visibleOptions.length - 1]
    }

    get currentLastVisibleOption() {
        return this.element.querySelector('.js-select-item.last')
    }
}

const selects = document.querySelectorAll('.js-select')
if (selects.length) {
    selects.forEach((select) => {
        new BaseSelect(select)
    })
}

